import { ServiceApi } from "./ServiceApiWithLoading";
import Software from '../model/Software';
import SoftwareVersionLink from '../model/SoftwareVersionLink';
import { PaginationOptions, promiseGetBlob, promiseRequest, promiseSendFormData } from './ServiceApi';

export default class SoftwareApi extends ServiceApi<Software> {

    constructor() {
        super('softwareVersion');
        this.updateProduct = this.updateProduct.bind(this);
    }

    async updateProduct(softwareId: number, list: number[] | null) {
        var baseUrl = this.getBaseUrl();
        var result = await promiseRequest(baseUrl + `${softwareId}/products/`, 'PUT', list || undefined, true);
        return result;
    }

    async uploadFile(data: File, softwareId: number | string, type: number | string): Promise<any> {
        var baseUrl = this.getBaseUrl();
        const formData = new FormData();

        formData.append('type', String(type));
        formData.append('file', data);

        try {
            var result = await promiseSendFormData(baseUrl + `${softwareId}/uploadFile/`, 'POST', formData);
            return result;
        } catch {
            return null;
        }
    }

    async deleteFile(softwareId: number | string, type: number | string) {
        var baseUrl = this.getBaseUrl();
        var result = await promiseRequest(baseUrl + `${softwareId}/${type}/deleteFile/`, 'DELETE', {}, true);
        return result;
    }

    async updateLinks(softwareVersionId: string | number, list: SoftwareVersionLink[]) {
        var baseUrl = this.getBaseUrl();
        var result = await this.promiseWithLoading(promiseRequest(baseUrl + `${softwareVersionId}/updateLinks/`, 'PUT', list || undefined, true));
        return result;
    }

    async getExportCsvList(options: PaginationOptions<Software>): Promise<Blob | null> {
        var url = this.getBaseUrl() + 'exportList';
        url = this.getUrl(url, options);
        return await this.promiseWithLoading(promiseGetBlob(url));
    }

}

